(() => {
const initializeMobileNavigation = (root = document) => {
  root.querySelectorAll('[data-mobile-nav-row-toggle]').forEach((row) => {
    if (row.dataset.rowToggleReady) return;
    const labelButton = row.querySelector('[data-mobile-nav-row-label]');
    const iconButton = row.querySelector('[data-mobile-nav-row-icon]');

    if (!labelButton || !iconButton) return;
    row.dataset.rowToggleReady = 'true';

    const syncState = () => {
      const expanded = row.classList.contains('mobile-nav--expanded');
      const expandedValue = expanded ? 'true' : 'false';

      labelButton.setAttribute('aria-expanded', expandedValue);
      iconButton.setAttribute('aria-expanded', expandedValue);
      iconButton.setAttribute('aria-label', `${expanded ? 'Collapse' : 'Expand'} ${labelButton.textContent.trim()} menu`);
    };

    const toggleRow = () => {
      row.classList.toggle('mobile-nav--expanded');
      syncState();
    };

    labelButton.addEventListener('click', toggleRow);
    iconButton.addEventListener('click', (event) => {
      // Prevent the theme's wrapper-level submenu handler from toggling this
      // controlled row a second time.
      event.stopPropagation();
      toggleRow();
    });
    syncState();
  });

  root.querySelectorAll('[data-brand-finder]').forEach((finder) => {
    if (finder.dataset.brandFinderReady) return;
    const search = finder.querySelector('[data-brand-search]');
    const status = finder.querySelector('[data-brand-status]');
    const emptyState = finder.querySelector('[data-brand-empty]');
    const loadMore = finder.querySelector('[data-brand-load-more]');
    const list = finder.querySelector('.brand-finder__list');
    const extraData = finder.querySelector('[data-brand-extra]');
    const pageSize = Number.parseInt(finder.dataset.brandPageSize, 10) || 8;
    let visibleLimit = pageSize;

    if (!search || !status || !emptyState || !list) return;
    finder.dataset.brandFinderReady = 'true';

    const normalize = (value) => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase();

    const brands = Array.from(finder.querySelectorAll('[data-brand-item]'), (item) => ({
      name: item.dataset.brandName || item.textContent.trim(),
      normalized: normalize(item.dataset.brandName || item.textContent.trim()),
      url: item.querySelector('a').getAttribute('href'),
      active: item.classList.contains('mobile-nav__item--active'),
      element: item,
    }));
    // Support old section HTML too, including Ajax-rendered/theme-editor headers.
    try {
      const extras = extraData ? JSON.parse(extraData.textContent) : [];
      extras.forEach(([name, url, active]) => {
        brands.push({ name, normalized: normalize(name), url, active, element: null });
      });
    } catch (error) {
      // Server-rendered links and the All brands destination remain usable.
      console.warn('Additional brands could not be initialized.', error);
    }

    const createBrandLink = (brand, index) => {
      const item = document.createElement('li');
      const desktop = finder.dataset.brandContext === 'desktop' || finder.classList.contains('brand-finder--desktop');
      item.className = desktop ? 'brand-finder__item' : 'mobile-nav__item';
      if (brand.active) item.classList.add('mobile-nav__item--active');
      item.dataset.brandItem = '';
      item.dataset.brandName = brand.name;
      item.dataset.brandPosition = String(index);
      const link = document.createElement('a');
      link.setAttribute('href', brand.url);
      link.className = desktop ? 'site-nav__link' : 'mobile-nav__link';
      if (desktop) {
        const wrapper = document.createElement('span');
        wrapper.className = 'site-nav--link-wrapper';
        const text = document.createElement('span');
        text.className = 'site-nav--link-text animated-underline';
        text.textContent = brand.name;
        wrapper.append(text);
        link.append(wrapper);
      } else {
        link.textContent = brand.name;
      }
      item.append(link);
      brand.element = item;
      return item;
    };

    const updateBrands = () => {
      const query = normalize(search.value.trim());
      let matchCount = 0;
      const visible = document.createDocumentFragment();

      brands.forEach((brand, index) => {
        const matches = !query || brand.normalized.includes(query);
        const withinVisibleLimit = query || index < visibleLimit;
        if (matches) matchCount += 1;
        if (matches && withinVisibleLimit) {
          const item = brand.element || createBrandLink(brand, index);
          item.hidden = false;
          visible.append(item);
        }
      });
      list.replaceChildren(visible);

      emptyState.hidden = !query || matchCount !== 0;
      if (loadMore) loadMore.hidden = Boolean(query) || visibleLimit >= brands.length;
      status.textContent = query
        ? `${matchCount} ${matchCount === 1 ? 'brand' : 'brands'} found.`
        : '';
    };

    search.addEventListener('input', updateBrands);
    loadMore?.addEventListener('click', () => {
      visibleLimit = Math.min(visibleLimit + pageSize, brands.length);
      updateBrands();
      status.textContent = `${visibleLimit} of ${brands.length} brands shown.`;
    });

    updateBrands();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeMobileNavigation());
} else {
  initializeMobileNavigation();
}
document.addEventListener('shopify:section:load', (event) => initializeMobileNavigation(event.target));
})();
